import { render, staticRenderFns } from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=template&id=05339e26&scoped=true"
import script from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioneElastomeroComponent.vue?vue&type=style&index=0&id=05339e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05339e26",
  null
  
)

export default component.exports